import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800">
      <h1 className="text-3xl font-bold text-[#264790] mb-8">Privacy Policy</h1>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 1 – What Do We Do With Your Information?</h2>
      <p>
        When you purchase something from our store, we collect personal information you give us such as your name, address, and email.
        Additionally, we automatically receive your computer’s IP address to help us learn about your browser and operating system.
      </p>
      <p className="mt-2">
        Email marketing (if applicable): With your permission, we may send you emails about our store, new products, and updates.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 2 – Consent</h2>
      <p><strong>How do you get my consent?</strong><br />
        When you provide personal information to complete a transaction, place an order, or arrange delivery, we assume your consent for collection and use for that purpose only.
        For secondary uses (e.g., marketing), we will ask for your expressed consent.
      </p>
      <p className="mt-2"><strong>How do I withdraw my consent?</strong><br />
        You can withdraw consent anytime by emailing <a href="mailto:svalearn360@gmail.com" className="text-blue-600">svalearn360@gmail.com</a> or writing to:  
        <br />Sva Learn, KHB Colony, Bangalore – 560079, Karnataka, India.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 3 – Disclosure</h2>
      <p>
        We may disclose your information if required by law or if you violate our Terms of Service.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 4 – Payment</h2>
      <p>
        We use Razorpay for payment processing. Your card details are encrypted and not stored on Razorpay or our servers.
        Razorpay complies with PCI-DSS standards to securely handle card data.
        For more, see <a href="https://razorpay.com" target="_blank" rel="noopener noreferrer" className="text-blue-600">razorpay.com</a>.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 5 – Third-Party Services</h2>
      <p>
        Third-party providers only collect and use your data to the extent required for their services.
        Some may operate in different jurisdictions, subjecting your data to those legal frameworks.
      </p>
      <p className="mt-2">
        Once you leave our site or are redirected, you are no longer governed by this Privacy Policy.
      </p>
      <p className="mt-2">
        <strong>Links:</strong> We are not responsible for the privacy practices of other websites and recommend reviewing their policies.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 6 – Security</h2>
      <p>
        We take reasonable precautions to protect your personal information from loss, misuse, unauthorized access, disclosure, or destruction.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 7 – Cookies</h2>
      <p>
        We use cookies to maintain user sessions. They are not used to personally identify you on other websites.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 8 – Age of Consent</h2>
      <p>
        By using this site, you confirm that you are the age of majority in your jurisdiction or have given consent for minors to use it.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">SECTION 9 – Changes to This Privacy Policy</h2>
      <p>
        We may update this policy anytime. Changes take effect immediately upon posting.
        If our company is acquired or merged, your data may be transferred to the new owner.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Questions and Contact Information</h2>
      <p>
        For access, correction, or deletion of your data, or to register a complaint, contact our Privacy Compliance Officer at <a href="mailto:spiriton20@gmail.com" className="text-blue-600">spiriton20@gmail.com</a> or write to:
      </p>
      <p className="mt-2">
        Sva Learn,<br />
        KHB Colony,<br />
        Bangalore – 560079,<br />
        Karnataka, India.
      </p>
    </div>
  );
}
